import { useCallback } from 'react';
import { useAtom } from 'jotai';
import { authAtom } from '../Data/Atoms';
import { 
    extractClaims, 
    canAccessPath as canAccessPathHelper, 
    canPerformAction as canPerformActionHelper,
    Claims,
    Permission 
} from '../helpers/AuthorizationManager';

export function useAuthorization() {
    const [auth] = useAtom(authAtom);
    const claims = extractClaims(auth);

    const canAccessPath = useCallback(
        (path: string) => canAccessPathHelper(claims, path),
        [auth]
    );
    const canPerformAction = useCallback(
        (action: Permission) => canPerformActionHelper(claims, action),
        [auth]
    );

    return {
        canPerformAction,
        canAccessPath,
        claims,
    };
}

